module.exports = BVHOCs;